import {getWarehouses} from '@/api/module/warehouse';
import {ApiSortOrder, ApiSortsDerived} from '@/api/meta/odata';
import Warehouse, {ApiWarehouse, WarehouseFilters} from '@/model/Warehouse';
import {createVersionedStorage} from './types';

const useWarehousesStore = createVersionedStorage<
  WarehouseFilters, ApiSortsDerived<ApiWarehouse>, Warehouse[]
>('warehouses', {
  fetchFn: getWarehouses,
  defaultData: [],
  defaultFilters: {
    Niederlassung: 0,
  },
  defaultSorts: [['Lagerhalle', ApiSortOrder.Asc]],
});

export default useWarehousesStore;
